import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'
import { DEV_ADMIN_EMAIL, SKIP_SUPABASE_AUTH } from '../lib/auth-config'
import { useAuth } from './AuthProvider'

export function LoginPage() {
  const { session, profile, initializing, unauthorized, signInWithPassword } = useAuth()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState<string | null>(null)
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    document.title = 'Entrar · ISEN EDUCAE'
  }, [])

  if (SKIP_SUPABASE_AUTH) {
    if (initializing || !profile) {
      return <div className="loading">Entrando automaticamente…</div>
    }
    return <Navigate to="/" replace />
  }

  if (initializing) {
    return <div className="loading">Carregando sessão…</div>
  }

  if (session && !profile && !unauthorized) {
    return <div className="loading">Carregando perfil…</div>
  }

  if (session && profile) {
    return <Navigate to="/" replace />
  }

  if (unauthorized) {
    return <Navigate to="/acesso-negado" replace />
  }

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!email.trim() || !password) {
      setError('Informe e-mail e senha')
      return
    }
    setBusy(true)
    setError(null)
    try {
      await signInWithPassword(email.trim(), password)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'E-mail ou senha inválidos')
      setBusy(false)
    }
  }

  return (
    <div className="login-page">
      <form className="login-card" onSubmit={handleSubmit}>
        <div className="login-brand">
          <span className="login-logo">ISEN</span>
          <h1>EDUCAE</h1>
          <p>Gestão de Merenda Escolar · Timon/MA</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <div className="field">
          <label htmlFor="email">E-mail</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="seu@email.com"
            disabled={busy}
          />
        </div>
        <div className="field">
          <label htmlFor="password">Senha</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            disabled={busy}
          />
        </div>
        <button type="submit" className="btn btn-primary login-btn" disabled={busy}>
          {busy ? 'Entrando…' : 'Entrar'}
        </button>
        <p className="login-hint">
          Acesso restrito a usuários cadastrados pela SEMED / ISEN EDUCAE.
          {SKIP_SUPABASE_AUTH && (
            <>
              <br />
              <span style={{ fontSize: 11 }}>Dev local: {DEV_ADMIN_EMAIL}</span>
            </>
          )}
        </p>
      </form>
    </div>
  )
}

export function AcessoNegadoPage() {
  const { signOut, user, session, profile, initializing, unauthorized, authFailureMessage } =
    useAuth()

  if (initializing) {
    return <div className="loading">Carregando sessão…</div>
  }

  // Rota pública: após "Sair" (ou sem sessão) nada redirecionava — leva ao login.
  if (!session && !profile) {
    return <Navigate to="/login" replace />
  }

  // Usuário autorizado que caiu aqui (link antigo) volta para a app.
  if (session && profile && !unauthorized) {
    return <Navigate to="/" replace />
  }

  return (
    <div className="login-page">
      <div className="login-card">
        <h1>Acesso não autorizado</h1>
        <p>
          {authFailureMessage ||
            (user?.email
              ? `O e-mail ${user.email} não possui cadastro ativo.`
              : 'Sua conta não possui permissão.')}{' '}
          {!authFailureMessage && 'Contate o administrador.'}
        </p>
        <button type="button" className="btn btn-secondary" onClick={() => signOut()}>
          Sair
        </button>
      </div>
    </div>
  )
}
